<template>
  <div v-if="isshow" class="modal-overlay">
    <div class="modal-content">
      <div class="modal-header">
        <h2>{{ $t('_mm._xgmm') }}</h2>
        <button class="close-btn" @click="close">×</button>
      </div>

      <div class="modal-body">
        <form @submit.prevent="onSubmit">
          <div class="form-group">
            <label>{{ $t('_mm._dqmm') }}</label>
            <input v-model="security.old_passwd" type="password" required />
          </div>

          <div class="form-group">
            <label>{{ $t('_mm._xmm') }}</label>
            <input v-model="security.new_passwd" type="password" required />
          </div>

          <div class="form-group">
            <label>{{ $t('_mm._qrxmm') }}</label>
            <input v-model="security.confirm_passwd" type="password" required />
          </div>

          <div class="form-actions">
            <button type="button" class="cancel-btn" @click="close">{{ $t('_mm._qx') }}</button>
            <button type="submit" class="submit-btn">{{ $t('_mm._qrxg') }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isshow: false,
      //账户安全
      security: {
        old_passwd: '',
        new_passwd: '',
        confirm_passwd: ''
      }
    }
  },
  created() {},
  methods: {
    show() {
      this.isshow = true
    },
    close() {
      this.isshow = false
      this.security = {
        old_passwd: '',
        new_passwd: '',
        confirm_passwd: ''
      }
    },
    onSubmit() {
      const that = this

      this.$message.loading({ content: this.$t('_a._bcz'), key: 'msg' })
      that.$api.user
        .updatePwd(this.security)
        .then((res) => {
          if (res.code == 1) {
            that.$message.warning({ content: res.msg, key: 'msg' })
            return
          }
          // 更新
          that.$message.success({ content: res.msg, key: 'msg' })

          setTimeout(function () {
            //localStorage.removeItem(that.$Const.KEY_TOKEN)
            //localStorage.removeItem(that.$Const.KEY_INFO)
            // that.$router.push({ name: 'index' })
            that.close()
          }, 500)
        })
        .catch((err) => {
          console.log('err', err)
        })
    }
  }
}
</script>

<style></style>
